import axios from "axios";
import "./interceptors";

// Adapter for the Admin app-log viewer. The API returns camelCase rows from
// `client_logs` (crash/error/diagnostic entries the mobile app mirrors via
// POST /logs). Pagination meta is reshaped to the legacy `{ totalRecords, ... }`
// shape the shared <Pagination> component expects.

function toLegacyPagination(meta) {
  return {
    totalRecords: meta.total,
    totalPages: meta.totalPages,
    currentPage: meta.page,
    pageSize: meta.limit,
  };
}

export function getLogs({ page = 1, pageSize = 20, level = "", platform = "", search = "" } = {}) {
  const params = new URLSearchParams({ page: String(page), limit: String(pageSize) });
  if (level) params.set("level", level);
  if (platform) params.set("platform", platform);
  if (search) params.set("search", search);
  const url = `api/v1/admin/logs?${params.toString()}`;

  return () =>
    axios.get(url).then((res) => ({
      data: res.data.data,
      pagination: toLegacyPagination(res.data.meta),
    }));
}

/**
 * Delete the logs matching the CURRENT filters.
 *
 * Scoped deliberately, and the same query shape the listing uses — the button
 * promises "clear what I am looking at", so an unfiltered call is the only one
 * that wipes everything. Returns `{ deleted }` so the UI can confirm precisely
 * instead of saying "done".
 */
export function clearLogs({ level = "", platform = "", search = "" } = {}) {
  const params = new URLSearchParams();
  if (level) params.set("level", level);
  if (platform) params.set("platform", platform);
  if (search) params.set("search", search);
  const qs = params.toString();
  const url = `api/v1/admin/logs${qs ? `?${qs}` : ""}`;

  return () => axios.delete(url).then((res) => res.data);
}
